// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { Button, Toastr } from "../../revvComponents";

// Action Imports
import {
  getSubscriptionCheckoutSessionID,
  getCustomerPortalURL,
} from "../../actions/SettingsActions/settingsActions";

class ShowUserLimitIncreaseRequestPopupV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  _onSubmit = () => {
    this.setState({ isLoading: true });
    this.props.getCustomerPortalURL().catch(() => {
      this.setState({ isLoading: false });
      Toastr.showToastr({
        type: "failure",
        message: "Oops, Something went wrong!!",
        timeout: 3000,
      });
    });
  };

  render() {
    return (
      <Modal
        open
        onClose={() => this.props.onClose("showUserConsumptionPopup", false)}
        center
        closeOnOverlayClick={false}
        className="">
        <div className="userlimitincreaserequest-container">
          <section className="userlimitincreaserequest-info-section">
            <div className="userlimitincreaserequest-welcome-msg">
              Wow! You now have {this.props.userConsumptionRecord.limit} or more
              users in your account, that&apos;s great.
            </div>
            <div className="userlimitincreaserequest-upsale-msg">
              Click on manage plan to buy more users or upgrade plan.
            </div>
          </section>

          <section className="userlimitincreaserequest-info-section">
            <Button
              type="four"
              data-test="phoneNumber-submission"
              className="btn btn-primary planchangerequest-submit-btn"
              onClick={() => this._onSubmit()}
              isLoading={this.state.isLoading}>
              Manage Plan
            </Button>
          </section>

          <hr />
          <section className="userlimitincreaserequest-info-section">
            <div className="userlimitincreaserequest-upsale-msg">
              If you need any help, write to us at{" "}
              <span className="userlimitincreaserequest-email-contact">
                support@revv.so
              </span>
            </div>
          </section>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { billingInfo } = state.CommonStore;

  return { billingInfo };
};

const mapDispatchToProps = {
  getSubscriptionCheckoutSessionID,
  getCustomerPortalURL,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ShowUserLimitIncreaseRequestPopupV2);
